<div class="bar-container">
  <div class="bar">

    <ng-container *ngFor="let item of getItems(); let i = index;">
        <a [routerLink]="getLink(item.url)" class="item" [class.selected]="isSelected(item)" [class.black]="item.title == 'blackFriday'" *ngIf="i < maxItemsDisplayed" (click)="itemClicked(item)">{{getString(item.title)}}</a>
        <a [routerLink]="getLink(item.url)" class="item" [class.selected]="isSelected(item)" *ngIf="i >= maxItemsDisplayed && showMore == true" (click)="itemClicked(item)">{{getString(item.title)}}</a>
    </ng-container>

    <span *ngIf="!showMore && getItems().length >= maxItemsDisplayed" class="item blue-text" (click)="showMore = true">{{getString('more')}}</span>
    <span *ngIf="showMore" class="item blue-text" (click)="showMore = false">{{getString('less')}}</span>
  </div>
</div>